import URL from '../url'
import Request from '../request'

/**
 *
 * @param {*} priceId
 */
export const createStripeSessionService = (priceId, trialDays, successReturnUrl) =>
  new Request(URL.API, URL.PAYMENT_SESSION).post({priceId, trialDays, successReturnUrl})